import * as io from 'io-ts';
import { string } from '@shared/core/types/common';

const rootDefinition: io.MixedObject<OLO.Config.API> = {
    key: string,
    base: string,
};

export const apiSchema = io.type(rootDefinition);
